export const DEFAULT = 'default'
export const EU_REGION1 = 'eu1'
